<body>
  <div class="grid-overlay">
    <app-page-header>
      <button class="header-action-btn" (click)="goToTemplates()">{{ 'updatePortalFeatures.navigation.back' | translate }}</button>
    </app-page-header>
    <div class="personalize-content">
      <div class="second-headboard">
        <h1>{{ 'updatePortalFeatures.title' | translate }}</h1>
        <!-- <img src="../../../assets/icons/3412.png" alt="logo de Billcentrix"> -->
        <div class="linked-icons" >
          <button (click)="goToTemplates()" >{{ 'updatePortalFeatures.navigation.templates' | translate }}</button>
          <button class="active">{{ 'updatePortalFeatures.navigation.customization' | translate }}</button>
          @if (!showPaymentButton) {
            <button (click)="goToPortals()">{{ 'updatePortalFeatures.navigation.save' | translate }}</button>
          }
          @if (showPaymentButton) {
            <button  (click)="processPayment()">{{ 'updatePortalFeatures.navigation.activatePortal' | translate }}</button>
          }
          <!-- <img src="../../assets/icons/1_cuenta_off.png" alt="Paso 1: Cuenta" (click)="goToEdit()" >
          <img src="../../assets/icons/2_portales_off.png" alt="Paso 2: Portal" (click)="goToTemplates()" >
          <img src="../../assets/icons/3_personalizar_on.png" alt="Paso 3: Personalizar" >
          <img src="../../assets/icons/4_planes_off.png" alt="Paso 4: Planes" (click)="goToPlans()"> -->
        </div>
      </div>
      <div class="options-content">
        <!-- <div class="selected-theme">
        <h1>Tema seleccionado: <strong>{{ selectedTheme }}</strong></h1>
        <p>Puedes cambiar el template cuando quieras</p>
        <div class="change-btn">
          <button mat-icon-button [matMenuTriggerFor]="menuPlan">Cambiar</button>
          <mat-menu #menuPlan="matMenu" class="menu">
            <button mat-menu-item (click)="changeTheme('Básico')">Básico</button>
            <button mat-menu-item (click)="changeTheme('Práctico')">Práctico</button>
            <button mat-menu-item (click)="changeTheme('Contempo')">Contempo</button>
          </mat-menu>
        </div>
      </div> -->
      <app-update-slider (paletteSelected)="handlePaletteSelected($event)" [storedPalette]="selectedPalette"></app-update-slider>
      <div class="brand">
        <h1>{{ 'updatePortalFeatures.yourBrand.title' | translate }}</h1>
        <div class="grid-brand">
          <div class="upload-file">
            <p class="principal-text">{{ 'updatePortalFeatures.yourBrand.description' | translate }}</p>
            <div class="upload">
              <img src="../../../assets/icons/subir.png" alt="subir archivo">
              <p class="action-description">{{ 'updatePortalFeatures.yourBrand.uploadFile' | translate }}</p>
            </div>
            <div class="preview">
              <!-- <img src="../../../assets/icons/ver.png" alt="vista previa">
              <p class="action-description">Vista previa</p> -->



              <input class="upload-photo" type="file" id="formFile" accept="image/png, image/jpeg, .svg"  (change)="onLogoChange($event)" >
            </div>
          </div>
          <div class="image-width">
            <div class="line-horizontal"></div>
            <span class="line-text-horizontal">200 pixels</span>
            <div class="line-vertical"></div>
            <span class="line-text-vertical">50 pixels</span>
            <img src="../../../assets/images/BRAND3.png" alt="medidas del logo">
            <br>
              <br>
                <br>
                  @if (logo64) {
                    <img [src]="logo64" alt="foto" width="250" height="100">
                  }

                </div>
              </div>
            </div>
            <div class="main-image">
              <div class="grid-main-image">
                <div class="left">
                  <h1>{{ 'updatePortalFeatures.mainImage.title' | translate }}</h1>
                  <p class="principal-text">{{ 'updatePortalFeatures.mainImage.description' | translate }}</p>
                  <div class="upload">
                    <img src="../../../assets/icons/subir.png" alt="subir archivo">
                    <p class="action-description">{{ 'updatePortalFeatures.mainImage.uploadFile' | translate }}</p>
                  </div>
                  <div class="preview">
                    <input class="upload-photo" type="file" id="formFile" accept="image/png, image/jpeg, image/svg"  (change)="onPrincipalChange($event)" >
                    <!-- <img src="../../../assets/icons/ver.png" alt="vista previa">
                    <p class="action-description">Vista previa</p> -->
                  </div>
                  <div class="sample-measurements">
                    <div class="line-horizontal"></div>
                    <span class="line-text-horizontal">1440 pixels</span>
                    @if (principal64) {
                      <img [src]="principal64" alt="foto" width="710" height="180">
                    }
                    <div class="line-vertical"></div>
                    <span class="line-text-vertical">720 pixels</span>
                  </div>
                </div>
                <div class="right">
                  <img class="section" src="../../../assets/images/indicadores-pag.png" alt="sectores de la pagina">
                  <img class="sample" src="../../../assets/images/pag-min.png" alt="muestra de la pagina">
                </div>
              </div>
            </div>
            <div class="promotional-banner">
              <div class="grid-promotional-banner">
                <div class="left">
                  <h1>{{ 'updatePortalFeatures.promotionalBanner.title' | translate }}</h1>
                  <p class="principal-text">{{ 'updatePortalFeatures.promotionalBanner.description' | translate }}</p>
                  <div class="upload">
                    <img src="../../../assets/icons/subir.png" alt="subir archivo">
                    <p class="action-description">{{ 'updatePortalFeatures.promotionalBanner.uploadFile' | translate }}</p>
                  </div>
                  <div class="preview">
                    <!-- <img src="../../../assets/icons/ver.png" alt="vista previa">
                    <p class="action-description">Vista previa</p> -->
                    <input class="upload-photo" type="file" id="formFile" accept="image/png, image/jpeg, image/svg"  (change)="onPromotionalChange($event)" >

                  </div>
                  <div class="frequent-questions">
                    <!-- <img src="../../../assets/icons/informacion2.png" alt="icono preguntas frecuentes">
                    <p>Haz clic aquí para preguntas frecuentes</p> -->
                  </div>
                </div>
                <div class="right">
                  <div class="sample-measurements">
                    <div class="line-horizontal"></div>
                    <span class="line-text-horizontal">320 pixels</span>
                    @if (promotional64) {
                      <img [src]="promotional64" alt="foto" width="160" height="260">
                    }
                    <div class="line-vertical"></div>
                    <span class="line-text-vertical">400 pixels</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="main-image">
              <div class="grid-main-image">
                <div class="left">
                  <h1>{{ 'updatePortalFeatures.generalData.title' | translate }}</h1>
                  <div class="grid-general-data">
                    <div class="left">
                      <div class="items">
                        <label for="image-title">{{ 'updatePortalFeatures.generalData.imageTitle' | translate }}</label>
                        <input  [formControl]="form.controls['page_title']" type="text" [placeholder]="'updatePortalFeatures.generalData.imageTitlePlaceholder' | translate">
                        @if (form.controls['page_title'].hasError('required') && form.controls['page_title'].touched) {
                          <small
                          class="form-error-msg"> {{ 'updatePortalFeatures.generalData.imageTitleError' | translate }} </small>
                        }
                      </div>
                      <div class="items">
                        <label for="description">{{ 'updatePortalFeatures.generalData.pageDescription' | translate }}</label>
                        <textarea type="textarea" [formControl]="form.controls['description_page']"
                        [placeholder]="'updatePortalFeatures.generalData.pageDescriptionPlaceholder' | translate"></textarea>
                        @if (form.controls['description_page'].hasError('required') && form.controls['description_page'].touched) {
                          <small
                          class="form-error-msg"> {{ 'updatePortalFeatures.generalData.pageDescriptionError' | translate }} </small>
                        }
                      </div>

                      <div class="items">
                        <label for="action">{{ 'updatePortalFeatures.generalData.plansTitle' | translate }}</label>
                        <input [formControl]="form.controls['price_title']"  type="text" [placeholder]="'updatePortalFeatures.generalData.plansTitlePlaceholder' | translate">
                        @if (form.controls['price_title'].hasError('required') && form.controls['price_title'].touched) {
                          <small
                          class="form-error-msg"> {{ 'updatePortalFeatures.generalData.plansTitleError' | translate }} </small>
                        }
                      </div>
                    </div>
                    <div class="rihgt">

                      <div class="items">
                        <label for="banner-text">{{ 'updatePortalFeatures.generalData.bannerTitle' | translate }}</label>
                        <input [formControl]="form.controls['banner_title']" type="text" [placeholder]="'updatePortalFeatures.generalData.bannerTitlePlaceholder' | translate">
                        @if (form.controls['banner_title'].hasError('required') && form.controls['banner_title'].touched) {
                          <small
                          class="form-error-msg"> {{ 'updatePortalFeatures.generalData.bannerTitleError' | translate }} </small>
                        }
                      </div>

                      <div class="items">
                        <label for="banner-description">{{ 'updatePortalFeatures.generalData.bannerDescription' | translate }}</label>
                        <input [formControl]="form.controls['description_banner']"  type="text" [placeholder]="'updatePortalFeatures.generalData.bannerDescriptionPlaceholder' | translate">
                        @if (form.controls['description_banner'].hasError('required') && form.controls['description_banner'].touched) {
                          <small
                          class="form-error-msg"> {{ 'updatePortalFeatures.generalData.bannerDescriptionError' | translate }} </small>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <img class="sample" src="../../../assets/images/datosPortalpng.png" alt="muestra de la pagina">
                </div>
              </div>
            </div>
            <div class="main-image">
              <div class="grid-main-image">
                <div class="left">
                  <h1>{{ 'updatePortalFeatures.language.title' | translate }}</h1>
                  <div class="grid-general-data">
                    <div class="left">
                      <div class="items">
                        <label for="language-select">{{ 'updatePortalFeatures.language.label' | translate }}</label>
                        <select id="language-select" [formControl]="form.controls['language']">
                          <option value="es">{{ 'updatePortalFeatures.language.spanish' | translate }}</option>
                          <option value="en">{{ 'updatePortalFeatures.language.english' | translate }}</option>
                        </select>
                        @if (form.controls['language'].hasError('required') && form.controls['language'].touched) {
                          <small
                          class="form-error-msg"> {{ 'updatePortalFeatures.language.error' | translate }} </small>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
        <div class="buttons">
          <!-- <div class="preview-mobile" >
          <button class="finish" (click)="preview()">Vista previa</button>
        </div> -->
        <div class="action-buttons">
          <button class="back-btn" (click)="goToPortals()">{{ 'updatePortalFeatures.mySubscriptions' | translate }}</button>
          <!-- <button class="finish" (click)="sendConfiguration()"*ngIf="exist" >Guardar y continuar</button> -->
          <!-- <button class="finish" (click)="sendConfiguration()"  *ngIf="!exist">Continuar</button> -->
        </div>
        <div class="action-buttons">
          <!-- <div class="preview" (click)="preview()">
          <button class="finish" (click)="preview()">Vista previa</button>
        </div> -->
        <button id="save" class="finish" (click)="sendConfiguration()">{{ 'updatePortalFeatures.save' | translate }}</button>
      </div>
    </div>
  </div>
</body>